import React, { useEffect } from "react";

import { useLocation } from "react-router-dom";
import { filterLiveArticles } from "supercell-frontend-base/src/utils/targeting/filter-live-articles";

import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";
import { CommunityView } from "./view";

export const CommunityController = () => {
    const { pathname: pagePath } = useLocation();
    const filterArticles = (articles: any) => filterLiveArticles(articles);
    const { trackPageView } = useSnowplowContext();

    useEffect(() => {
        trackPageView("Community", pagePath);
        window.history.pushState({ home: true }, "");
    }, []);

    return <CommunityView filterArticles={filterArticles} />;
};
